(function (angular) {
    'use strict';

    angular.module('profiles')
        /**
         *
         */
        .controller('addProfileModal', ['$scope', '$stateParams', 'profilesService', '$uibModalInstance', 'growlService', 'profileSchema', '$timeout', 'allowOtherProperties', function ($scope, $stateParams, profilesService, $uibModalInstance, growlService, profileSchema, $timeout, allowOtherProperties) {
            $scope.profileSchema = [];
            $scope.allowOtherProperties = allowOtherProperties;
            $scope.autoGenerateId = true;
            $scope.duplicates = {};
            var excluded = ['id','firstName', 'lastName', 'email', 'email', 'phoneNumber', 'fbMessengerId'];
            for (var i in profileSchema) {
                if (!profileSchema[i].onlyObjects && !profileSchema[i].path.startsWith('_') && !excluded.includes(profileSchema[i].path) && !profileSchema[i].path.startsWith('facebook')) {
                    $scope.profileSchema.push(profileSchema[i]);
                }
            }

            $scope.variables = [];

            
            $scope.addVariable = function () {
                $scope.variables.push({});
            };

            $scope.deleteVariable = function (index) {
                $scope.variables.splice(index, 1);
            };
            function trim(string) {
                return string.trim().replace(/ /g, "_");
            }

            $scope.checkDuplicate = function (index) {
                $scope.duplicates[index] = false;
                for (var i in $scope.variables) {
                    if (i != index && $scope.variables[i].key.toLowerCase() == $scope.variables[index].key.toLowerCase()) {
                        $scope.duplicates[index] = true;
                    }
                }
                if (["id", "firstname", "lastname", "email", "phonenumber"].includes($scope.variables[index].key.toLowerCase())) {
                    $scope.duplicates[index] = true;
                }
                return $scope.duplicates[index];

            };

            $scope.checkDuplicates = function () {
                for (var i in $scope.duplicates) {
                    if ($scope.duplicates[i]) return true;
                }
                return false;
            };

            $scope.customCheck = function (value) {
                if (value) {
                    return (!/^[a-zA-Z0-9-_]*$/.test(value) || value.startsWith("_"));
                }
                return false;
            };
            $scope.customChecks = function () {
                for (var i in $scope.newProperties) {
                    if ($scope.customCheck($scope.newProperties[i].key)) return true;
                }
                return false;
            };
            $scope.allowEdit = function () {
                $scope.conflict = {};
            };

            $scope.showProfiles = function () {
                $scope.conflict.showProfiles = true;
            }
            $scope.save = function (skipValidation) {
                $scope.conflict = {};
                var data = {
                    id: $scope.id,
                    firstName: $scope.firstName,
                    lastName: $scope.lastName,
                    email: $scope.email,
                    phoneNumber: $scope.phoneNumber

                };
                if (skipValidation) {
                    createProfile(data);
                }
                else {
                    profilesService.getProfilesWithQueries($stateParams.pickedApiSpaceId, "phoneNumber='" + data.phoneNumber + "'").then(function (phoneResult) {
                        $scope.conflict.data = [];
                        if (phoneResult.length > 0) {
                            $scope.conflict.phoneConflict = true;
                            $scope.conflict.data = phoneResult;
                        }
                        profilesService.getProfilesWithQueries($stateParams.pickedApiSpaceId, 'email=' + data.email).then(function (emailResult) {
                            if (emailResult.length > 0) {
                                $scope.conflict.emailConflict = true;
                            }
                            if (phoneResult.length === 0 && emailResult.length === 0) {
                                createProfile(data);
                            }
                            else {

                                for (var i in emailResult) {
                                    var check = false;
                                    for (var j in $scope.conflict.data) {
                                        if (emailResult[i].id == $scope.conflict.data[j].id) {
                                            check = true;
                                        }
                                    }
                                    if (!check) {
                                        $scope.conflict.data.push(emailResult[i]);
                                    }
                                }
                            }
                        });
                    });
                }
            };

            function createProfile(data) {
                for (var i in $scope.variables) {
                    var variable = $scope.variables[i];
                    if (variable.key && variable.value && variable.kay != 'id') {
                        if(variable.key.indexOf('.')>=0){
                            var keys = variable.key.split('.');
                            if(!data[keys[0]]){
                                data[keys[0]] = {};
                            }
                            data[keys[0]][keys[1]] = variable.value;
                        }
                        else{
                            data[trim(variable.key)] = variable.value;
                        }
                    }
                }
                profilesService.addProfile($stateParams.pickedApiSpaceId, data).then(function (result) {
                    growlService.success('Profile successfully added');
                    $uibModalInstance.close(result);
                }).catch(function (error) {
                    if (error.status == 409) {
                        growlService.danger("Profile wasn't created - this profile already exists");
                    }
                    else {
                        growlService.danger("Profile wasn't created due to: " + error.statusText);
                    }

                });
            }
            $scope.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };
        }]);
       
})(window.angular); 